import {
  BookOpen,
  Flame,
  CreditCard,
  Shield,
} from "lucide-react";
import type { LucideIcon } from "lucide-react";

export interface ResourceLink {
  title: string;
  description: string;
  href: string;
  icon?: LucideIcon;
}

export interface ResourceConfig {
  title?: string;
  subtitle?: string;
  columns?: 3 | 4 | 6;
  links: ResourceLink[];
}

export const bbqResourceLinks: ResourceConfig = {
  title: "HELPFUL GUIDES & INFO",
  links: [
    {
      title: "Complete Buying Guide",
      description: "Everything you need to know about choosing the perfect outdoor kitchen.",
      href: "/buying-guide",
      icon: BookOpen,
    },
    {
      title: "How-To Guides",
      description: "Tips, tutorials, and expert advice for outdoor cooking.",
      href: "/guides",
      icon: Flame,
    },
    {
      title: "Financing Options",
      description: "Flexible payment plans to fit your budget.",
      href: "/financing",
      icon: CreditCard,
    },
    {
      title: "Warranty Info",
      description: "Learn about our industry-leading lifetime warranty.",
      href: "/warranty",
      icon: Shield,
    },
  ],
};
